import { useState, useEffect } from 'react'
import { getFactionsAPI } from '../services/factions'

export default function UseFactionAll(orgId, divisionId) {
  const [data, setData] = useState([])
  useEffect(() => {
    const param = { 
      orgId,
      divisionId
      
    }
    const getData = async () => {
      const result = await getFactionsAPI(param)
      if (!result) return
      if (result.result.length > 0) {
        const newData = result.result.map((d, i) => {
          return {
            value: d.id,
            label: `${d.faction_en} (${d.faction})`,
            count_emp: d.count_emp,
            data: d.faction
          }
        })

        setData(newData)
      } else {
        setData([])
      }
    }
    if (divisionId && orgId ) {
      getData()
    }
  }, [divisionId, orgId])

  return data
}
